module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_c('b-button', {
    attrs: {
      "variant": "secondary",
      "size": "sm"
    },
    on: {
      "click": _vm.openLinkRequirementsDialog
    }
  }, [_c('icon', {
    attrs: {
      "name": "pencil"
    }
  }), _vm._v("\n      Edit\n    ")], 1), _vm._v(" "), (_vm.requirements.length > 0) ? _c('table', {
    staticClass: "rm-table right-panel-requirements-table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.requirements), function(requirement) {
    return _c('tr', [_c('td', [_c('a', {
      attrs: {
        "href": _vm.getNewTabLink(requirement),
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(requirement.prefix) + _vm._s(requirement.display_id ? requirement.display_id : requirement.requirement_id))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(requirement.name))])])
  }))]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Name")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7de79d6a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/webPanels/IssueViewRequirementsRightPanelView.vue
// module id = 1021
// module chunks = 1